import { PropTypes } from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import './Footnote.scss';

export default function Footnote({ numNote, textNote }) {
  const idMessage = 'widget.footnote-paragraph' + { numNote };

  return (
    <>
      <p className="Widget__paragraph-footnote">
        <span className="Widget__badge-footnote">{numNote}</span>
        <FormattedMessage id={idMessage} defaultMessage={textNote} />
      </p>
    </>
  );
}

Footnote.propTypes = {
  numNote: PropTypes.number,
  textNote: PropTypes.string,
};
